<template>
  <div
    v-if="sender === 'customer'"
    class="balloon balloon-text cursor-pointer"
    @click.exact="bubblePopup"
    @click.shift.left.exact="bubbleShift"
    v-html="linkify(message.payload.message)"
  ></div>
  <div
    v-else
    class="balloon balloon-text"
    @click.shift.left.exact="bubbleShift"
    v-html="linkify(message.payload.message)"
  ></div>
</template>

<script>
export default {
  name: 'PayloadText',
  props: {
    sessionId: String,
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    linkify(inputText) {
      if (inputText.includes('mailto:')) return inputText

      let replacedText, replacePattern1, replacePattern2, replacePattern3

      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
      replacedText = inputText.replace(
        replacePattern1,
        '<a href="$1" target="_blank">$1</a>'
      )

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim
      replacedText = replacedText.replace(
        replacePattern2,
        '$1<a href="//$2" target="_blank">$2</a>'
      )

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim
      replacedText = replacedText.replace(
        replacePattern3,
        '<a href="mailto:$1">$1</a>'
      )

      return replacedText
    },
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    },
    bubblePopup() {
      this.$emit('learnPopup', {
        word: this.message.payload.message,
        query: {
          session_id: this.sessionId,
          bot_conversation_id: this.conversation.conversation_id,
          sender: this.sender
        }
      })
    }
  }
}
</script>
